
export { useWalletTutorial } from "/home/runner/work/capsicum/capsicum/libs/features/nc-wallet/shared/src/hooks/useWalletTutorial.ts"